import { useState, useEffect } from "react";
import Lottie from 'lottie-react';
import { FaArrowUp } from "react-icons/fa";

import { AnimatePresence, motion } from "framer-motion";

import circle from '../assets/img/circle.webp'
import scrollDown from '../assets/img/animations/scrollDownWhite.json'

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > 1000);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const fadeInScroll = {
        initial: {
            opacity: 0,
            y: 60
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                ease: "easeInOut",
                type: "spring",
                duration: 0.35,
                // delay: 2,
                damping: 6,
            }
        },
        exit: {
            opacity: 0,
            y: 60,
            transition: {
                ease: "easeInOut",
                duration: 0.35
            }
        },
    };

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={isVisible}
                variants={fadeInScroll}
                initial="initial"
                animate="animate"
                exit="exit"
                className="fixed xs:bottom-[1rem] lg:bottom-[1rem] xl:bottom-[2rem] 2xl:bottom-[2.5rem] xs:right-[0.5rem] 2xl:right-[1rem] z-50"
            >
                {/* <div className={`absolute w-full h-full xs:hidden xl:block ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
                    <img
                        src={circle}
                        alt="Circle"
                        className='w-full h-full rotateInfinite scale-[1.55] z-[200]'
                    />
                </div> */}
                <button
                    onClick={scrollToTop}
                    className={`z-[300] bg-gradient-to-br from-primaryRichBlue to-primaryRichGreen trns500 cursor-pointer group flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-[3.25rem] xs:h-[3.25rem] xsp:w-[3.5rem] xsp:h-[3.5rem] lg:w-[3rem] lg:h-[3rem] xl:w-[3.5rem] xl:h-[3.5rem] 2xl:w-[4rem] 2xl:h-[4rem] xs:p-[0.55rem] xsp:p-[0.575rem] md:p-[0.6rem] lg:p-[0.55rem] xl:p-[0.6rem] 2xl:p-[0.75rem] rounded-full mx-auto xs:border-[3px] 2xl:border-[4px] border-slate-200/95 hover:border-slate-200 shadow-2xl xs:outline-[3px] 2xl:outline-[4px] outline-white/60 hover:outline-slate-900/80 scrollShadowXl ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
                >
                    {/* <FaArrowUp className="xs:text-[0.9rem] xsp:text-[0.95rem] md:text-[1.15rem] lg:text-[0.85rem] xl:text-[1rem] 2xl:text-[1.1rem]" /> */}
                    <Lottie
                        animationData={scrollDown}
                        loop={true}
                        style={{ width: '100%', height: '100%' }}
                        className='ml-[0.05rem] rotate-180'
                    />
                </button>
            </motion.div>
        </AnimatePresence>
    );
};

export default ScrollToTop;
